import NewEcharts from "@/components/Echart/NewEcharts.vue";
import { reactive, toRefs } from "vue";
import { useRoute } from "vue-router";
import { registryIndicator, registryJgytIndicator } from '@/api/system1/tenant';
import { ElMessage } from "element-plus";
export default {
  name: "DeviceStateHistory",
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    apiType: {
      type: String,
      default: 'registryIndicator' // 'registryIndicator' 或 'registryJgytIndicator'
    }
  },
  components: {
    NewEcharts
  },
  setup(props) {
    let route = useRoute();
    let type = route.query.type;
    const state = reactive({
      lineChart: {},
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        handle: () => methods.loadData()
      }],
      form: {
        indicator: "",
        //标识符
        id: null,
        time: [],
        opStartTime: "",
        opEndTime: ""
      },
      cloneForm: null,
      searchFormData: [{
        prop: "time",
        label: "",
        type: "datetimerange",
        span: 8,
        format: "YYYY-MM-DD HH:mm:ss",
        valueFormat: "YYYY-MM-DD HH:mm:ss",
        change(val) {
          if (val && val.length === 2) {
            const startTime = new Date(val[0]);
            const endTime = new Date(val[1]);
            const diffTime = endTime.getTime() - startTime.getTime();
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            // 限制最大跨度为一个月（30天）
            if (diffDays > 30) {
              // 如果超过30天，自动调整为30天
              const maxEndTime = new Date(startTime.getTime() + 30 * 24 * 60 * 60 * 1000);
              // 格式化日期为 YYYY-MM-DD HH:mm:ss
              const formatDate = date => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
              };
              const maxEndTimeStr = formatDate(maxEndTime);
              state.form.time = [val[0], maxEndTimeStr];
              state.form.opStartTime = val[0];
              state.form.opEndTime = maxEndTimeStr;
              // 提示用户
              ElMessage.warning('时间跨度不能超过一个月，已自动调整为一个月');
            } else {
              state.form.opStartTime = val[0];
              state.form.opEndTime = val[1];
            }
          } else {
            state.form.opStartTime = val ? val[0] : '';
            state.form.opEndTime = val ? val[1] : '';
          }
        },
        pickerOptions: {
          disabledDate(time) {}
        }
      }],
      checkStateShow: false,
      myChart: null,
      unit: null,
      legend: "",
      loading: false,
      timeSelect: "",
      showDatePicker: false,
      title: "",
      tableData: {
        rows: [],
        total: 0
      }
    });
    const methods = reactive({
      show(row, title) {
        state.title = title;
        state.form.indicator = row.indicator;
        state.form.id = props.id || route.query.actId;
        state.unit = row.unit;
        state.legend = row.legend;
        methods.loadData();
        state.checkStateShow = true;
      },
      async loadData() {
        if (!state.form.id) {
          return;
        }
        state.lineChart = {
          "legend": [state.legend],
          "series": [{
            "name": state.legend,
            "data": [],
            "unit": state.unit
          }],
          "xaxis": []
        };
        const apiFunc = props.apiType === 'registryJgytIndicator' ? registryJgytIndicator : registryIndicator;
        console.log(apiFunc);
        apiFunc(state.form).then(res => {
          state.lineChart = {
            "legend": [state.legend],
            "series": [{
              "name": state.legend,
              "data": res.data.seriesData || [],
              //[100,100,89,34,56,45,100,100,56,45,100,100,100,100,89,34,56,45,100,100,56,45,100,100],
              "unit": state.unit
            }],
            "xaxis": res.data.xaxisData || []
            // "xaxis": [ "2025-05-22 19:20:14","2025-05-22 19:18:14", "2025-05-22 19:16:52","2025-05-22 19:11:52","2025-05-22 19:09:33",
            // "2025-05-22 19:03:17","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:18:14", "2025-05-22 19:16:52","2025-05-22 19:11:52","2025-05-22 19:09:33",
            // "2025-05-22 19:03:17","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14","2025-05-22 19:20:14"]
          };
        });
      },
      closeDialog() {
        state.showDatePicker = false;
        state.timeSelect = "";
        state.form.opStartTime = "";
        state.form.opEndTime = "";
        state.form.time = [];
        state.myChart && state.myChart.clear();
      },
      timeChange() {
        if (state.timeSelect && state.timeSelect.length) {
          state.form["opStartTime"] = state.timeSelect[0];
          state.form["opEndTime"] = state.timeSelect[1];
          methods.loadData();
        }
      }
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      type
    };
  }
};